export default __webpack_public_path__ + "static/media/rightBox.b8119d48.png";